import { cx } from '@emotion/css';

import { MotifComponent, useMotifStyles } from '../../motif';
import { emphasizedTextCss } from './EmphasizedText.styles';

type EmphasizedTextProps = {
  text: string;
};

export const EmphasizedText: React.FC<EmphasizedTextProps> = ({ text }) => {
  useMotifStyles(MotifComponent.EMPHASIZED_TEXT);
  return text ? (
    <em className={cx(MotifComponent.EMPHASIZED_TEXT, emphasizedTextCss)}>{text}</em>
  ) : null;
};
